module.exports = __webpack_public_path__ + "img/icon-2.40dbaf68.png";